import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

function NotGateIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="layer1"
        transform="translate(0,8)">
        <g
          id="g1978"
          transform="matrix(1.2540675,0,0,1.2540675,-2.6860324,0.69141616)">
          <path
            transform="matrix(-0.68973843,0,0,-0.71854123,82.156607,120.23166)"
            d="m 114.81937,176.93488 -25.712105,0 12.856055,-22.26734 z"
            id="path9043"
            opacity="0.3"
          />
          <path
            opacity="0.8"
            id="path9043-4"
            d="M 11.828437,9.096653 20.695902,-6.9033475 H 2.9609718 l 0.7518216,1.3554811 z m 0,-3.617716 L 5.9671413,-5.0956532 H 17.689735 Z"
          />
          <circle
            opacity="0.3"
            id="path4258-4"
            cx="11.828738"
            cy="9.9713268"
            r="2.2141263" />
          <path
            opacity="0.8"
            id="path4258-4-6"
            d="m 11.828588,7.6577028 c -1.268627,0 -2.3129996,1.0443726 -2.3129996,2.3129996 0,1.2686266 1.0443726,2.3129996 2.3129996,2.3129996 1.268627,0 2.313,-1.044373 2.313,-2.3129996 0,-1.268627 -1.044373,-2.3129996 -2.313,-2.3129996 z m 0,1.4389496 c 0.490961,0 0.87405,0.383089 0.87405,0.87405 0,0.4909606 -0.383089,0.8740496 -0.87405,0.8740496 -0.490961,0 -0.87405,-0.383089 -0.87405,-0.8740496 0,-0.490961 0.383089,-0.87405 0.87405,-0.87405 z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default NotGateIcon;

